var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details"},[_c('Header'),_c('EmployeeForm',{attrs:{"mode":"update"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }